import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SEOHead from "@/components/SEOHead";
import SEORelatedPages from "@/components/SEORelatedPages";
import { getSEOData } from "@/lib/seo-pages";

const seo = getSEOData("/pesnya-mame-v-podarok")!;

const faqItems = [
  { q: "Мама не пользуется Telegram — как ей отправить песню?", a: "Вы получите ссылку на красивую подарочную страницу, которую можно отправить в любой мессенджер — WhatsApp, Viber, SMS." },
  { q: "Можно ли упомянуть в песне конкретные семейные истории?", a: "Именно это и делает песню особенной. Расскажите про дачу, про её фирменные пирожки, про то, как она ждала вас с работы — всё это станет строчками." },
  { q: "Какой стиль лучше выбрать для мамы?", a: "Чаще всего выбирают мягкий поп или акустику — тёплые, негромкие, с душой. Но если мама любит что-то энергичное — можно и рок-балладу." },
  { q: "Сколько стоит создание песни?", a: "Демоверсия полностью бесплатна. Вы послушаете готовый трек и решите сами, хотите ли получить полную версию." },
  { q: "Успею ли я, если праздник завтра?", a: "Да. Весь процесс занимает около трёх минут." },
  { q: "А если я не знаю, что написать?", a: "Бот задаст наводящие вопросы. Просто ответьте честно — про маму, про ваши отношения, про то, за что вы ей благодарны." },
];

const PesnyaMameVPodarok = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead title={seo.title} description={seo.description} canonical={seo.canonical} jsonLd={{ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqItems.map((item) => ({ "@type": "Question", name: item.q, acceptedAnswer: { "@type": "Answer", text: item.a } })) }} />
      <Navbar />
      <main className="pt-24 pb-16">
        <article className="container px-4 mx-auto max-w-3xl">
          <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold mb-6 text-foreground leading-tight">Песня маме в подарок</h1>

          <div className="space-y-4 text-muted-foreground leading-relaxed mb-10">
            <p>Она носила вас на руках — буквально. Потом учила завязывать шнурки, проверяла уроки до полуночи. Вы выросли, а она по-прежнему спрашивает: «Ты поел?»</p>
            <p>Как отблагодарить за всё это? <strong className="text-foreground">Песня маме в подарок</strong> — это то, что она будет переслушивать, показывать подругам и тихо плакать от счастья каждый раз.</p>
          </div>

          <section className="mb-12">
            <h2 className="font-display text-xl sm:text-2xl font-bold mb-4 text-foreground">Как превратить «спасибо, мам» в музыку</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>Вы просто рассказываете. Про то, как она пекла шарлотку по воскресеньям. Про дачу, где вы ловили светлячков. Выбираете стиль — нежная акустика, тёплый поп. Через три минуты получаете демоверсию.</p>
            </div>
          </section>

          <div className="my-10 text-center">
            <Button size="lg" className="shadow-soft rounded-full px-8 text-base" asChild>
              <Link to="/create">💐 Создать песню для мамы</Link>
            </Button>
            <p className="text-muted-foreground text-sm mt-3">Бесплатная демоверсия. Без регистрации.</p>
          </div>

          <section className="mb-12">
            <h2 className="font-display text-xl sm:text-2xl font-bold mb-4 text-foreground">Почему мамы плачут от таких подарков</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>Потому что мама привыкла отдавать. Персональная песня — именно об этом. В ней звучат конкретные детали вашей семьи.</p>
              <p>Это ценнее любого подарка с витрины. На <Link to="/" className="text-primary hover:underline">главной странице HitChef</Link> вы найдёте примеры того, как это звучит.</p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-display text-xl sm:text-2xl font-bold mb-4 text-foreground">Когда и как подарить песню маме</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p><strong className="text-foreground">На <Link to="/pesnya-na-den-rozhdeniya" className="text-primary hover:underline">день рождения</Link>.</strong> Соберите семью за столом, попросите тишину и включите трек.</p>
              <p><strong className="text-foreground">На 8 марта или День матери.</strong> Отправьте ссылку на подарочную страницу с утра.</p>
              <p><strong className="text-foreground">Просто так.</strong> Без повода. Иногда подарки без причины — самые сильные.</p>
              <p><strong className="text-foreground">На <Link to="/pesnya-na-yubiley" className="text-primary hover:underline">юбилей</Link> — от всей семьи.</strong> Это будет семейная реликвия. Подробнее — на странице <Link to="/pesnya-v-podarok" className="text-primary hover:underline">песня в подарок</Link>.</p>
            </div>
          </section>

          <div className="my-10 text-center">
            <Button size="lg" className="shadow-soft rounded-full px-8 text-base" asChild>
              <Link to="/create">🎵 Сказать маме «спасибо» музыкой</Link>
            </Button>
            <p className="text-muted-foreground text-sm mt-3">Три минуты — и у вас подарок, которого она не ожидает.</p>
          </div>

          <section className="mb-12">
            <h3 className="font-display text-lg sm:text-xl font-bold mb-3 text-foreground">Когда весь зал притих</h3>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>На юбилее Татьяны Петровны — шестьдесят лет — сын попросил тамаду сделать паузу. В песне было всё: её утренние блины, сад с яблонями, поездки на море. Гости замолчали. Кто-то потянулся за салфеткой.</p>
              <p>Татьяна Петровна дослушала, обняла сына и тихо сказала: «Откуда ты всё это помнишь?»</p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-display text-xl sm:text-2xl font-bold mb-6 text-foreground">Частые вопросы о песне для мамы</h2>
            <Accordion type="single" collapsible className="space-y-2">
              {faqItems.map((item, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border border-border rounded-xl px-5 bg-card">
                  <AccordionTrigger className="text-left hover:no-underline text-sm font-medium text-foreground">{item.q}</AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-sm leading-relaxed">{item.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </section>

          <div className="my-10 text-center">
            <Button size="lg" className="shadow-soft rounded-full px-8 text-base" asChild>
              <Link to="/create">❤️ Создать песню, которую мама будет хранить вечно</Link>
            </Button>
            <p className="text-muted-foreground text-sm mt-3">Это займёт три минуты. А запомнится — на всю жизнь.</p>
          </div>

          <SEORelatedPages pages={seo.relatedPages || []} />
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default PesnyaMameVPodarok;
